export const MEMBERSHIP_APIS = {
  getMembershipsList: "community/memberships/list",
  getIndividualMembership: "community/memberships/get",
  createMembership: "community/memberships/create",
  editMembership: "community/memberships/edit",
  deleteMemebership: "community/memberships/delete",
  getChannelList: "community/channel/paginated/list",
  getCustomLinkList: "community/custom/link/list",
  getCustomLinksByMembership: "community/custom/link/membership/list",
  addCustomLinkMembershipMapping: "community/custom/link/membership/add",
  removeCustomLinkMembershipMapping: "community/custom/link/membership/remove",
  addMembershipChannels: "community/membership/channels/add",
  removeMembershipChannels: "community/membership/channels/remove",
  membershipSettings: "users/adminpanel/mylisting/:listingId/memberships",
  reordering: "community/reorder/elements",
};

export const MEMBERSHIP_API_PATHNAME = {
  membershipSettings: (listingUuid) =>
    `users/adminpanel/mylisting/${listingUuid}/memberships`,
  getMembershipsList: (listingUuid) =>
    `community/memberships/list?community_listing_uuid=${listingUuid}`,
  getIndividualMembership: ({ listingUuid, membershipUuid }) =>
    `community/memberships/get?community_listing_uuid=${listingUuid}&membership_uuid=${membershipUuid}`,
  getMembershipsListView: ({ listingUuid }) =>
    `community/memberships/list?community_listing_uuid=${listingUuid}&view=true`,
  getChannelList: ({ listingUuid, page, pageSize }) =>
    `community/channel/paginated/list?community_listing_uuid=${listingUuid}&page=${page}&page_size=${pageSize}`,
  getChannelListByMembershipId: (listingUuid, membershipUuid) =>
    `community/channel/paginated/list?community_listing_uuid=${listingUuid}&membership_uuid=${membershipUuid}&page=all`,
  deleteMemebership: ({ listingUuid, membershipUuid }) =>
    `community/memberships/delete?community_listing_uuid=${listingUuid}&membership_uuid=${membershipUuid}`,
  getCustomLinkList: ({ listingUuid }) =>
    `community/custom/link/list?community_listing_uuid=${listingUuid}&page=all`,
  getCustomLinksByMembership: ({ membershipUuid, page = "all" }) =>
    `community/custom/link/membership/list?membership_uuid=${membershipUuid}&page=${page}`,
};
